import {makeFunction} from "./TemplateFunctions";
import {VehicleWeightCommandTypes} from "../../constans/mqttMessages";

export const doTare = makeFunction(VehicleWeightCommandTypes.SET_R320_TARE, "doR320Tare", []);

export const resetWeighting = makeFunction(VehicleWeightCommandTypes.SET_RESET_WEIGHTING, "resetWeighting", []);